import {Page} from "@/PageDescriptors";
import LimitsSummaryPage from "@/components/limits-summary/LimitsSummaryPage";
import domains from "./domains";
import personalExtensions from "./personal-extensions";
import GlobalNumberSearch from "@/components/GlobalNumberSearch";
import EndpointStatus from "@/components/endpoint-status/EndpointStatus";
import {useAuth} from "@/context/AuthProvider";
import ImplementorPage from "@/components/mac-address-management/MACAddressManagement";
import DeviceVariantList from "@/components/device-variant/DeviceVariantList";
import PrivateRoutingDestination from "@/components/private-routing-destination/PrivateRoutingDestination";
import SpecialDays from "@/components/special-days/SpecialDays";
import UpdateSystemSettings from "@/components/system-settings/UpdateSystemSettings";
import AuditLogsPage from "./audit-logs/AuditLogs";
import {useFeatureHide} from "@/hooks";
import {BasePath} from "@/basePaths";
import {defineMessage} from "react-intl";

const RootPage = () => {
    const auth = useAuth();

    if (!auth.hasPermission("view_licence_state")) return <div />;

    return <LimitsSummaryPage />;
};

const rootPage: Page<"", BasePath> = {
    path: "",
    label: null, // not used for root page
    items: [
        domains,
        {
            path: "search",
            label: defineMessage({id: "searchNumbers", defaultMessage: "Search numbers"}),
            permission: "search_number",
            contentComponent: GlobalNumberSearch,
        },
        {
            path: "endpoint-status",
            label: defineMessage({id: "endpointStatus.title", defaultMessage: "Endpoint status"}),
            permission: "view_domain_devices_status",
            contentComponent: EndpointStatus,
        },
        {
            path: "mac-address-management",
            label: defineMessage({id: "macAddressManagement", defaultMessage: "MAC address management"}),
            permission: "install_device",
            contentComponent: ImplementorPage,
        },
        personalExtensions,
        {
            path: "device-variants",
            label: defineMessage({id: "deviceVariantsPage", defaultMessage: "Device variants"}),
            permission: "add_device_variant",
            contentComponent: DeviceVariantList,
        },
        {
            path: "custom-routing-destinations",
            label: defineMessage({
                id: "privateRoutingDestinations.label",
                defaultMessage: "Custom routing destinations",
            }),
            permission: "edit_superuser_domain",
            contentComponent: PrivateRoutingDestination,
        },
        {
            path: "special-days",
            label: defineMessage({id: "specialDays.label", defaultMessage: "Special days"}),
            permission: "edit_superuser_domain",
            contentComponent: SpecialDays,
        },
        {
            path: "system-settings",
            label: defineMessage({id: "system_settings", defaultMessage: "System settings"}),
            permission: "edit_system_settings",
            contentComponent: UpdateSystemSettings,
        },
        {
            path: "audit-logs",
            label: defineMessage({id: "audit_logs", defaultMessage: "Audit logs"}),
            permission: "view_audit_logs",
            contentComponent: AuditLogsPage,
            hideHook: useFeatureHide("auditLog"),
        },
    ],
    contentComponent: RootPage,
};

export default rootPage;
